<template>
  <v-menu
    v-model="menu"
    offset-y
    left
    max-width="400"
    :close-on-content-click="false"
  >
    <template #activator="{ on, attrs }">
      <v-btn icon class="mr-2" v-bind="attrs" v-on="on">
        <v-badge
          :content="badgeContent"
          :value="unreadCount > 0"
          color="error"
          overlap
        >
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-subtitle-1 py-2">
        {{ $t("notifications.title") }}
      </v-card-title>
      <v-divider />
      <v-list
        v-if="visibleItems.length"
        dense
        class="overflow-y-auto py-0"
        max-height="400"
      >
        <v-list-item
          v-for="item in visibleItems"
          :key="item.id"
          @click="onItemClick(item)"
        >
          <v-list-item-icon class="mr-3 my-auto">
            <v-icon color="error">mdi-alert-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="{ 'font-weight-bold': !item.isRead }">
              {{
                $t(copyKey(item, "title"), {
                  fileName: item.payload?.fileName,
                })
              }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{
                $t(copyKey(item, "subtitle"), {
                  dsrName: item.payload?.dsrName,
                  year: item.payload?.year,
                  detectedPeriod: item.payload?.detectedPeriod,
                })
              }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-caption">
              {{ relativeTime(item.createdAt) }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="!item.isRead" class="my-auto">
            <v-icon size="10" color="techBlue">mdi-circle</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-card-text v-else class="text-center text--secondary">
        {{ $t("notifications.empty") }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          small
          color="techBlue"
          :disabled="unreadCount === 0"
          @click="onMarkAllRead"
        >
          {{ $t("notifications.mark-all-read") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { notificationCopyKey } from "@/utilities/notificationCopy";

const DROPDOWN_LIMIT = 20;

export default {
  name: "TheNotificationCenter",
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    ...mapGetters({
      items: "notifications/getItems",
      unreadCount: "notifications/getUnreadCount",
    }),
    visibleItems() {
      return this.items.slice(0, DROPDOWN_LIMIT);
    },
    badgeContent() {
      return this.unreadCount > 99 ? "99+" : this.unreadCount;
    },
  },
  methods: {
    ...mapActions({
      markAsRead: "notifications/markAsRead",
      markAllRead: "notifications/markAllRead",
    }),
    copyKey(item, suffix) {
      return notificationCopyKey(item.type, suffix);
    },
    onItemClick(item) {
      this.menu = false;
      if (!item.isRead) this.markAsRead(item.id);
      const current = this.$route;
      if (
        current.name === "dsr.info.index" &&
        Number(current.params.id) === Number(item.dsrQuestionnaireId)
      )
        return;
      this.$router.push({
        name: "dsr.info.index",
        params: { id: String(item.dsrQuestionnaireId) },
      });
    },
    onMarkAllRead() {
      this.markAllRead();
    },
    relativeTime(value) {
      // I timestamp arrivano in UTC, eventualmente senza suffisso di timezone
      const hasTimezone = /Z$|[+-]\d{2}:?\d{2}$/.test(value);
      const date = new Date(hasTimezone ? value : `${value}Z`);
      const minutes = Math.floor((Date.now() - date.getTime()) / 60000);
      if (minutes < 1) return this.$t("notifications.time-now");
      if (minutes < 60)
        return this.$t("notifications.time-minutes", { n: minutes });
      const hours = Math.floor(minutes / 60);
      if (hours < 24) return this.$t("notifications.time-hours", { n: hours });
      return this.$t("notifications.time-days", {
        n: Math.floor(hours / 24),
      });
    },
  },
};
</script>
